import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

// Mapeamento completo de eventos GTM descritivos por rota
const PAGE_EVENT_MAP: Record<string, string> = {
  '/': 'Pagina_Inicial',
  '/chat': 'Chat_Principal',
  '/chat/:id': 'Chat_Conversa_Especifica',
  '/chat-juridico': 'Chat_Juridico',
  '/chat-juridico/:id': 'Chat_Juridico_Conversa_Especifica',
  '/chat-plus': 'Chat_Plus',
  '/chat-docs': 'Chat_com_Documentos',
  '/casos': 'Lista_de_Casos',
  '/casos/:id': 'Detalhe_do_Caso',
  '/documentos': 'Lista_de_Documentos',
  '/documentos/:id': 'Documento_Especifico',
  '/melhorar-texto': 'Editor_de_Texto',
  '/configuracoes': 'Configuracoes',
  '/papel-timbrado': 'Papel_Timbrado',
  '/planos': 'Add_To_Cart',
  '/tema': 'Configuracao_de_Tema',
  '/compartilhamento': 'Compartilhamentos',
  '/paineladmin': 'Painel_Admin',
  '/notificacoes': 'Notificacoes',
  '/sugestoes': 'Sugestoes',
  '/tutoriais': 'Tutoriais',
  '/calculos': 'Calculadora_Juridica',
  '/legal': 'Termos_Legais',
  '/payment-success': 'Pagamento_Sucesso',
  '/payment-canceled': 'remove_from_cart',
};

// Função para verificar match de rotas dinâmicas (com :id)
const matchDynamicRoute = (pathname: string, pattern: string): boolean => {
  const patternParts = pattern.split('/');
  const pathParts = pathname.split('/');
  
  if (patternParts.length !== pathParts.length) return false;
  
  return patternParts.every((part, i) => {
    return part.startsWith(':') || part === pathParts[i];
  });
};

// Função para obter o evento correto baseado no pathname
const getEventForPath = (pathname: string): string => {
  // 1. Verificar match exato
  if (PAGE_EVENT_MAP[pathname]) {
    return PAGE_EVENT_MAP[pathname];
  }
  
  // 2. Verificar rotas dinâmicas (com :id)
  for (const [pattern, event] of Object.entries(PAGE_EVENT_MAP)) {
    if (pattern.includes(':') && matchDynamicRoute(pathname, pattern)) {
      return event;
    }
  }
  
  // 3. Fallback para rotas não mapeadas
  return 'Pagina_Desconhecida';
};

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Garante que o dataLayer existe
    if (typeof window !== 'undefined' && window.dataLayer) {
      const eventName = getEventForPath(location.pathname);
      
      // Envia evento personalizado para o GTM
      window.dataLayer.push({
        event: eventName,
        page_path: location.pathname,
        page_title: document.title,
        page_location: window.location.href
      });

      // console.log('📊 GTM Event tracked:', {
      //   event: eventName,
      //   path: location.pathname,
      //   title: document.title
      // });
    }
  }, [location.pathname]);
};
